import { formatFileSize, isDefinedGlobally } from './utils';

const messages = {
  _default: (field) => `Արժեքը ${field} անթույլատրելի է`,
  after: (field, [target, inclusion]) => `${field} պետք է լինի, հետո ${inclusion ? 'կամ հավասար ' : ''}${target}`,
  alpha: (field) => `${field} դաշտը կարող է պարունակել միայն տառային նիշ`,
  alpha_dash: (field) => `${field} դաշտը կարող է պարունակել alphanumeric նիշ, ինչպես նաեւ dashes եւ ընդգծում`,
  alpha_num: (field) => `${field} դաշտը կարող է պարունակել միայն տառային-թվային նիշ`,
  alpha_spaces: (field) => `${field} դաշտը կարող է պարունակել միայն տառային նիշեր, ինչպես նաեւ բացեր`,
  before: (field, [target, inclusion]) => `${field} պետք է լինի, մինչեւ ${inclusion ? 'կամ հավասար ' : ''}${target}`,
  between: (field, [min, max]) => `${field} դաշտը պետք է լինի միջեւ ${min} եւ ${max}`,
  confirmed: (field) => `${field} հաստատումը չի համընկնում`,
  credit_card: (field) => `${field} դաշտը անթույլատրելի է`,
  date_between: (field, [min, max]) => `${field} պետք է լինի միջեւ ${min} եւ ${max}`,
  date_format: (field, [format]) => `${field} պետք է լինի ձեւաչափով ${format}`,
  decimal: (field, [decimals = '*'] = []) => `${field} դաշտը պետք է լինի թվային եւ կարող է պարունակել ${!decimals || decimals === '*' ? '' : ' ' + decimals} տասնորդական կետեր`,
  digits: (field, [length]) => `${field} դաշտը պետք է լինի թվային եւ պարունակի ուղիղ ${length} թվեր`,
  dimensions: (field, [width, height]) => `${field} դաշտը պետք է լինի ${width} պիքսել ${height} փիքսել`,
  email: (field) => `${field} դաշտը պետք է լինի վավեր էլփոստի հասցե`,
  excluded: (field) => `${field} դաշտը պետք է լինի թույլատրելի արժեք`,
  ext: (field) => `${field} դաշտը պետք է լինի թույլատրելի ֆայլ`,
  image: (field) => `${field} դաշտը պետք է լինի Պատկեր`,
  included: (field) => `${field} դաշտը պետք է լինի թույլատրելի արժեք`,
  integer: (field) => `${field} դաշտը պետք է լինի Ամբողջ թիվ`,
  ip: (field) => `${field} դաշտը պետք է լինի վավեր IP հասցեն`,
  ip_or_fqdn: (field) => `${field} դաշտը պետք է լինի վավեր IP հասցեն կամ ամբողջական տիրույթի անունը`,
  length: (field, [length, max]) => {
    if (max) {
      return `${field} երկարությունը պետք է լինի միջեւ ${length} եւ ${max}`;
    }

    return `${field} երկարությունը պետք է լինի ${length}`;
  },
  max: (field, [length]) => `${field} դաշտը չի կարող լինել ավելին, քան ${length} Անձնավորություններ`,
  max_value: (field, [max]) => `${field} դաշտը պետք է լինի ${max} կամ ավելի քիչ`,
  mimes: (field) => `${field} դաշտը պետք է ունենա թույլատրելի ֆայլի տեսակը`,
  min: (field, [length]) => `${field} դաշտը պետք է լինի ոչ պակաս ${length} Անձնավորություններ`,
  min_value: (field, [min]) => `${field} դաշտը պետք է լինի ${min} կամ ավելի`,
  numeric: (field) => `${field} դաշտը կարող է պարունակել միայն թվային նիշ`,
  regex: (field) => `${field} դաշտի ձեւաչափը սխալ է`,
  required: (field) => `Դաշտ ${field} պարտադիր է`,
  required_if: (field, [target]) => `${field} դաշտը պարտադիր է, երբ ${target} դաշտը ունի այդ արժեքը`,
  size: (field, [size]) => `${field} չափը պետք է լինի ավելի փոքր ${formatFileSize(size)}`,
  url: (field) => `${field} դաշտը թույլատրելի URL չէ`,
  isPhoneValid: (field) => `${field} պետք է լինի վավեր հեռախոսահամարը!`,
  isEmailUnique: (field) => `Employee այս ${field} արդեն գոյություն ունի համակարգում!!`,
  isIddUnique: (field) => `Դոնոր այս ${field} արդեն գոյություն ունի համակարգում!`,
  serviceCode: (field) => `${field} պետք է պարունակի 3-16 նիշ Ա-ից մինչեւ ես 0-9!!`,
  isRoleNameUnique: (field) => `Դերը այս անունով արդեն գոյություն ունի համակարգում:!`,
  isAlleleValid: (field, params, data) => data || "Սխալ կապի հետ սերվերի!",
  isBillNumberUnique: (field, params, data) => data || "Սխալ կապի հետ սերվերի!",
  isGroupGCodeExist: (field, params, data) => data || "Սխալ կապի հետ սերվերի!",
  isLocusGroupValid: (field, params) => `"Արժեքները" դաշտը պետք է լինի թույլատրելի հավաքածու:`,
  dateRangeRequired: (field, params) => `${field} պահանջվում.`,
  isLoginUnique: (field, params) => `Employee այս ${field} արդեն գոյություն ունի համակարգում!!`,
  positiveNumber: (field, params) => `Գինը պետք է լինի դրական թիվ!!`,
  isCodeUnique: (field, params) => `Դուք փնտրել էք-այս ${field} արդեն գոյություն ունի համակարգում!`
};

const locale = {
  name: 'ka',
  messages,
  attributes: {}
};

if (isDefinedGlobally()) {
  VeeValidate.Validator.localize({ [locale.name]: locale });
}

export default locale;
